export default {
  bind(el, binding) {
    el.__flashTimer = null

    const options = binding.value?.options || {}
    const hostClass = options.host || binding.arg || "flash-host"

    el.__flashHostClass = hostClass

    el.classList.add(hostClass)
  },

  update(el, binding) {
    const newValue = binding.value?.value ?? binding.value
    const oldValue = binding.oldValue?.value ?? binding.oldValue

    if (newValue === oldValue) return

    const options = binding.value?.options || {}

    const className =
      options.animate ||
      binding.arg ||
      "flash-animate"

    let duration =
      options.duration ||
      (binding.modifiers.fast ? 600 : binding.modifiers.slow ? 2000 : 1200)

    el.classList.remove(className)
    void el.offsetWidth
    el.classList.add(className)

    if (el.__flashTimer) clearTimeout(el.__flashTimer)

    el.__flashTimer = setTimeout(() => {
      el.classList.remove(className)
      el.__flashTimer = null
    }, duration)
  },

  unbind(el) {
    if (el.__flashTimer) clearTimeout(el.__flashTimer)
  },
}
